export const styles = {
  tabsWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media screen and (max-width: 768px)': {
      margin: '6px 0',
    },
  },

  tabsWrapperADM: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4%',
    '@media screen and (max-width: 768px)': {
      margin: '6px 0',
      gap: '0',
    },
  },

  tabWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
    '&:last-of-type': {
      marginRight: '0px',
    },
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'center',
      marginRight: 0,
      flex: 1,
    },
  },

  tab: {
    color: 'rgba(0, 0, 0, 0.26)',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
    '@media screen and (max-width: 768px)': {
      color: '#011533',
    },
  },

  activeTab: {
    color: '#000000',
    fontWeight: '700',
  },

  disabled: {
    background: 'rgba(0, 0, 0, 0.26)',
  },
  progressDraftBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
  },
  line: {
    position: 'absolute',
    width: '25%',
    height: '3px',
    marginLeft: '2px',
    alignItems: 'center',
    backgroundColor: '#1D2943',
    zIndex: '-1',
  },
  lineADM: {
    position: 'absolute',
    width: '32%',
    height: '3px',
    marginLeft: '2px',
    alignItems: 'center',
    backgroundColor: '#1D2943',
    zIndex: '-1',
  },
  notActiveLine: {
    position: 'absolute',
    width: '25%',
    height: '3px',
    marginLeft: '2px',
    alignItems: 'center',
    backgroundColor: '#CDCDF4',
    zIndex: '-1',
  },
  notActiveLineADM: {
    position: 'absolute',
    width: '32%',
    height: '3px',
    marginLeft: '2px',
    alignItems: 'center',
    backgroundColor: '#CDCDF4',
    zIndex: '-1',
  },
}
